module.exports = __webpack_public_path__ + "img/icon_industory.68fd4b01.svg";